import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { EstablishmentService } from '../../../services/establishment.service';
import { CookieService } from 'ngx-cookie-service';
import { Establishment } from '../../../models/Establishment';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-mon-etablissement',
  templateUrl: './mon-etablissement.component.html',
  styleUrl: './mon-etablissement.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class MonEtablissementComponent implements OnInit {
  establishment: Establishment;
  id: number;

  constructor(
    private establishmentService: EstablishmentService,
    private auth: AuthService
  ) {
    this.id = auth.id!;
  }
  ngOnInit() {
    this.getEstablishment();
  }

  getEstablishment() {
    this.establishmentService.getEstablishmentById(this.id).subscribe({
      next: (res) => {
        this.establishment = res;
      },
      error: () => {},
      complete: () => {},
    });
  }
  refreshData() {
    this.getEstablishment();
  }
}
